import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@knockrentals/knock-react';
import ThresholdSelect from './ThresholdSelect';
import {
  YELLOW_THRESHOLD_FIELD,
  RED_THRESHOLD_FIELD,
  YELLOW_THRESHOLD_OPTIONS,
  getRedThresholdOptions,
  applyThresholdChange,
} from './utils';

export const UNABLE_TO_LOAD_THRESHOLDS_MESSAGE =
  'Failed to load to-do list thresholds. Refresh to try again';

const TodoListThresholds = ({ preferences, onThresholdChanged }) => {
  const handleChange = (preference, field) => (value) => {
    const updatedPreference = applyThresholdChange(preference, field, value);
    onThresholdChanged(preference, updatedPreference);
  };

  return (
    <div className="prospect-crm-settings">
      <h3>Prospect CRM Settings</h3>

      {preferences.length === 0 ? (
        <Alert>{UNABLE_TO_LOAD_THRESHOLDS_MESSAGE}</Alert>
      ) : (
        <table className="wire-frame-table">
          <thead>
            <tr>
              <th>Rule</th>
              <th>Yellow</th>
              <th>Red</th>
            </tr>
          </thead>

          <tbody>
            {preferences.map((preference) => (
              <tr key={preference.todoRuleId}>
                <td>{preference.description}</td>

                <td className="text-center">
                  <ThresholdSelect
                    ariaLabel={`${preference.description} yellow threshold`}
                    value={preference.yellowThreshold}
                    options={YELLOW_THRESHOLD_OPTIONS}
                    onChange={handleChange(preference, YELLOW_THRESHOLD_FIELD)}
                  />
                </td>

                <td className="text-center">
                  <ThresholdSelect
                    ariaLabel={`${preference.description} red threshold`}
                    value={preference.redThreshold}
                    options={getRedThresholdOptions(preference.yellowThreshold)}
                    onChange={handleChange(preference, RED_THRESHOLD_FIELD)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

TodoListThresholds.propTypes = {
  preferences: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string.isRequired,
      redThreshold: PropTypes.string,
      todoRuleId: PropTypes.number.isRequired,
      yellowThreshold: PropTypes.string,
    }),
  ),
  onThresholdChanged: PropTypes.func.isRequired,
};

export default TodoListThresholds;
